import { Todo as TodoType } from 'api/clients/TodoClient'
import { CommentableType } from 'components/ActivityEvent/Types'
import { CommentV2 } from 'components/CommentV2/CommentV2'
import { Todo } from 'components/Todo/Todo'
import { sortBy } from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { CollabItem, CollabItemType } from 'stores/DocStore.types'
import { Comment } from 'types'
import { MaybeTrackedChange } from '../MaybeTrackedChange/MaybeTrackedChange'

const CommentItem = observer(({ item }: { item: Comment }) => {
  const docStore = useDocStore()
  const replies = computed(() =>
    sortBy(docStore.rootStore.comments.getByCommentable(item.id, CommentableType.COMMENT), 'created_at'),
  ).get()
  return <CommentV2 items={[item, ...replies]} />
})

export const TodoItem = observer(({ item }: { item: TodoType }) => {
  const docStore = useDocStore()
  const replies = computed(() =>
    sortBy(docStore.rootStore.comments.getByCommentable(item.id, CommentableType.TODO), 'created_at'),
  ).get()
  return <Todo items={[item, ...replies]} />
})

type Props = CollabItem

export const Item = observer(({ item, type }: Props) => {
  if (type === CollabItemType.Comment) {
    return <CommentItem item={item} />
  }

  if (type === CollabItemType.Todo) {
    return <TodoItem item={item} />
  }

  return <MaybeTrackedChange trackedChange={item} />
})
